

import { getMunicipalityNameByCode } from '@/services/municipalities'

/**
 * Realisation
 */
let Realisation = function ({
  ref, data,
}) {

  data = this.commonStructure({ ref, data })
  data.tenant = 'opcharge'

  //
  Object.keys(data).forEach(key => {
    this[key] = data[key]
  })
}

Realisation.prototype.generateAddressData = ({ model }) => {
  const CurrentLocation = model.CurrentLocation
  const location = CurrentLocation.Location
  const municipality = getMunicipalityNameByCode({ code: model.Municipality })
  const municipalityName = municipality && `(${municipality})`

  if (location?.StreetName) {
    return `${location.StreetName} ${location.HouseNumber} ${location.HouseNumberSuffix} ${location.CityName} ${municipalityName}`.replace('  ', ' ')
  }
  return ''
}

Realisation.prototype.generateSearchData = ({ model }) => { // , data
  return {
    City: model.CurrentLocation ? model.CurrentLocation.Location.CityName: '',
    Municipality: getMunicipalityNameByCode({ code: model.Municipality }) || '',
  }
}


export default Realisation
